import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/lightbulb-off.vue
var s = {
	name: "DtIconLightbulbOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--lightbulb-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Lightbulb Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.647.647a.5.5 0 0 1 .707 0l10 10a.5.5 0 1 1-.707.707L3.51 4.217c.032.349.163.746.587 1.173.435.401.733.931.849 1.513a.5.5 0 0 1-.981.195 1.805 1.805 0 0 0-.568-.994C2.647 5.354 2.5 4.6 2.5 4c0-.195.017-.39.05-.583a.501.501 0 0 1 .037-.123l-1.94-1.94a.5.5 0 0 1 0-.707ZM6 1.5a2.5 2.5 0 0 0-1.25.335.5.5 0 0 1-.5-.866A3.5 3.5 0 0 1 9.5 3.996c.01.66-.21 1.304-.626 1.818a.5.5 0 1 1-.778-.628A1.82 1.82 0 0 0 8.5 4.009V4A2.5 2.5 0 0 0 6 1.5ZM4 9a.5.5 0 0 1 .5-.5h3a.5.5 0 1 1 0 1h-3A.5.5 0 0 1 4 9Zm1 2.5a.5.5 0 0 1 0-1h2a.5.5 0 1 1 0 1H5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=lightbulb-off.js.map